import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';


// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';

import TrainingStaffResult from './TrainingStaffResult';
import TrainingStaffApprovedResult from './TrainingStaffApprovedResult';
import TrainingStaffDisapprovedResult from './TrainingStaffDisapprovedResult';
import TrainingSimulatorStaffDisapprovedResult from './TrainingSimulatorStaffDisapprovedResult';
import TrainingSimulatorStaffResult from './TrainingSimulatorStaffResult';
import TrainingSimulatorStaff from './TrainingSimulatorStaff';
import TrainingStaffPayment from './TrainingStaffPayment';
import getLocale from '../../../i18n/getLocale';

class TrainingResultsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      training_id: this.props.training_id,
      updated: this.props.updated,
      staff_available_list: [],
      training_certification_staffs: [],
      training_certification_instructors: [],
      modal: false,
      modal_tcs_id: [],
      modal_staff_name: null,
      modal_certification_name: null,
      modal_comment: null,
    };

    this.locale = getLocale();

    //bind específico
    this.finalizedAll = this.finalizedAll.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    this.setState({
      verify_finalized: newProps.verify_finalized,
      training_id: newProps.training_id,
      staff_available_list: newProps.staff_available_list,
      training_certification_staffs: newProps.training_certification_staffs,
      training_certification_instructors: newProps.training_certification_instructors,
      loaded: 1,
    });
  }

  finalizedAll (event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Treinamentos.EditarTreinamento.tabResultados.finalizarTodosOsCertificados);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.training_id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/treinamento/certificados/tripulantes/finalizar/todos', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tituloInstrutoresExaminadores}</h3>
  <hr/>
  {(this.state.training_certification_instructors === null || typeof this.state.training_certification_instructors === 'undefined') ?  <div><small><em>{this.locale.Treinamentos.EditarTreinamento.tabResultados.nenhumAlunoCadastrado}</em></small><hr/></div>
  :
  <div>
    {Object.keys(self.state.training_certification_instructors).map(function(staff) {
      return(
        <div>
          <div className="title-staff-trainings">
            <h5 className="page-title">{staff}</h5>
          </div>
          <table className="table table-staff-trainings">
            <tbody id="training-certification-staffs">
              {Object.keys(self.state.training_certification_instructors[staff]).map(function(k) {
                if (self.state.training_certification_instructors[staff][k].half_payment !== 0) {
                  return (
                    <tr>
                      <td className="col-md-4">
                        <h5><span className="label label-default">{self.state.training_certification_instructors[staff][k].certification_name}</span> <span className="label label-info">{(self.state.training_certification_instructors[staff][k].training_certification_type === "Instrutores") ? self.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaIntrutoresExaminadores.Instrutor : self.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaIntrutoresExaminadores.Examinador}</span> </h5>
                      </td>
                      <td className="col-md-8 text-center">
                        {self.state.training_certification_instructors[staff][k].status !== 2 ?
                          <TrainingStaffPayment training_certification_staff_id={self.state.training_certification_instructors[staff][k].id} hours={self.state.training_certification_instructors[staff][k].hours} status={self.state.training_certification_instructors[staff][k].status} date_start={self.state.training_certification_instructors[staff][k].date_start_str} date_finish={self.state.training_certification_instructors[staff][k].date_finish_str} certification_id={self.state.training_certification_instructors[staff][k].certification_id} updateData={self.props.updateData} handleAlert={self.props.handleAlert} />
                          : ""
                        }
                      </td>
                    </tr>
                  );
                }
                return (
                  <tr>
                    <td colspan="2">
                      {self.locale.Treinamentos.EditarTreinamento.tabResultados.tabelaIntrutoresExaminadores.PagamentoViaLogbook}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    })}
    <hr/>
  </div>
  }
  <h3 className="page-title">{this.locale.Treinamentos.EditarTreinamento.tabResultados.tituloTripulantes}</h3>
  <hr/>
  {(self.state.verify_finalized === 1) ?
    <button className="btn btn-lg btn-block btn-success" onClick={self.finalizedAll}><i className="fa fa-check"></i> {this.locale.Treinamentos.EditarTreinamento.tabResultados.botaoFinalizarTodos}</button>
    :
    ""
  }
  <hr/>
  {(this.state.training_certification_staffs === null || typeof this.state.training_certification_staffs === 'undefined') ?  <div><small><em>{this.locale.Treinamentos.EditarTreinamento.tabResultados.nenhumAlunoCadastrado}</em></small><hr/></div>
  :
  <div>
    {Object.keys(self.state.training_certification_staffs).map(function(staff) {
      return(
        <div>
          <div className="title-staff-trainings">
            <h5 className="page-title">{staff}</h5>
          </div>
          <table className="table table-staff-trainings">
            <tbody id="training-certification-staffs">
              {Object.keys(self.state.training_certification_staffs[staff]).map(function(k) {
                return (
                  <tr>
                    <td className="col-md-4">
                      <h5><span className="label label-default">{self.state.training_certification_staffs[staff][k].certification_name}</span></h5>
                    </td>
                    {(self.state.training_certification_staffs[staff][k].half_payment === 0) ?
                        <td className="col-md-8 text-center">
                          {(self.state.training_certification_staffs[staff][k].status === 1) ? <TrainingSimulatorStaffResult training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} pnf={self.state.training_certification_staffs[staff][k].pnf} hours={self.state.training_certification_staffs[staff][k].hours} hours_str={self.state.training_certification_staffs[staff][k].hours_str} finalized={self.state.training_certification_staffs[staff][k].finalized} date_start={self.state.training_certification_staffs[staff][k].date_start_str} date_finish={self.state.training_certification_staffs[staff][k].date_finish_str} certification_id={self.state.training_certification_staffs[staff][k].certification_id} updateData={self.props.updateData} handleAlert={self.props.handleAlert} /> : (self.state.training_certification_staffs[staff][k].status === 0) ?
                            <TrainingSimulatorStaffDisapprovedResult training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} pnf={self.state.training_certification_staffs[staff][k].pnf} result={self.state.training_certification_staffs[staff][k].result} hours={self.state.training_certification_staffs[staff][k].hours} confirmed={self.state.training_certification_staffs[staff][k].confirmed} hours_str={self.state.training_certification_staffs[staff][k].hours_str} status_str={self.state.training_certification_staffs[staff][k].status_str} />

                           : <TrainingSimulatorStaff training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} pnf={self.state.training_certification_staffs[staff][k].pnf} hours={self.state.training_certification_staffs[staff][k].hours_str} hours_str={self.state.training_certification_staffs[staff][k].hours_str} confirmed={self.state.training_certification_staffs[staff][k].confirmed} updateData={self.props.updateData} handleAlert={self.props.handleAlert} />
                          }
                        </td>
                      : (self.state.training_certification_staffs[staff][k].half_payment === 1) ?
                        <td className="col-md-8 text-center">
                          {(self.state.training_certification_staffs[staff][k].status === 1) ? <TrainingStaffApprovedResult training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} result={self.state.training_certification_staffs[staff][k].result} hours={self.state.training_certification_staffs[staff][k].hours} hours_str={self.state.training_certification_staffs[staff][k].hours_str} finalized={self.state.training_certification_staffs[staff][k].finalized} date_start={self.state.training_certification_staffs[staff][k].date_start_str} date_finish={self.state.training_certification_staffs[staff][k].date_finish_str} certification_id={self.state.training_certification_staffs[staff][k].certification_id} updateData={self.props.updateData} handleAlert={self.props.handleAlert} /> : (self.state.training_certification_staffs[staff][k].status === 0) ?  <TrainingStaffDisapprovedResult training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} result={self.state.training_certification_staffs[staff][k].result} hours={self.state.training_certification_staffs[staff][k].hours} confirmed={self.state.training_certification_staffs[staff][k].confirmed} hours_str={self.state.training_certification_staffs[staff][k].hours_str} status_str={self.state.training_certification_staffs[staff][k].status_str} /> : <TrainingStaffResult training_certification_staff_id={self.state.training_certification_staffs[staff][k].id} result={self.state.training_certification_staffs[staff][k].result} hours={self.state.training_certification_staffs[staff][k].hours_str} confirmed={self.state.training_certification_staffs[staff][k].confirmed} updateData={self.props.updateData} handleAlert={self.props.handleAlert} />

                          }
                        </td>
                      : ""
                    }
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    })}
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default TrainingResultsTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingResultsTab.js